import { AlertCircle, CheckCircle, Info, AlertTriangle } from 'lucide-react';

const variants = {
  error: {
    container: 'bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-800 text-red-700 dark:text-red-400',
    icon: AlertCircle,
  },
  warning: {
    container: 'bg-yellow-50 dark:bg-yellow-900/20 border-yellow-200 dark:border-yellow-800 text-yellow-700 dark:text-yellow-400',
    icon: AlertTriangle,
  },
  success: {
    container: 'bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-800 text-green-700 dark:text-green-400',
    icon: CheckCircle,
  },
  info: {
    container: 'bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800 text-blue-700 dark:text-blue-400',
    icon: Info,
  },
};

export default function Alert({ variant = 'error', children, className = '' }) {
  const config = variants[variant] || variants.error;
  const Icon = config.icon;

  return (
    <div className={`flex items-start gap-3 p-4 border rounded-lg text-sm ${config.container} ${className}`}>
      <Icon size={16} className="shrink-0 mt-0.5" />
      <div>{children}</div>
    </div>
  );
}
